<template ref="task-summary-dashboard">
  <v-content style="height: 100vh; max-height: calc(100%); overflow: hidden;">
    <v-container fluid pa-0 style="height: 100vh; max-height: calc(100%);">
      <v-row style="max-height: calc(100%);overflow: hidden;">
        <v-col
          style="height: 100vh; max-height: calc(100%); overflow: hidden; padding: 0; position: relative; align: center"
        >
          <v-container
            v-if="!loadingDone"
            px-12
            fluid
            style="height: 100vh; max-height: calc(90%);"
          >
            <loading-status-box
              :message="'Loading Coaching Summary Data'"
              :type="'loading'"
              :messageStyle="'text-wrap: nowrap; font-size:1rem;'"
              :padding="0"
            ></loading-status-box>
          </v-container>
          <v-container
            v-else
            pa-12
            pt-0
            fluid
            style="height: 100vh; max-height: calc(90%); overflow-y: scroll;"
          >
            <!-- breadcrumbs -->
            <breadcrumbs></breadcrumbs>

            <!-- coaching summary filters banner -->
            <filters ref="filters" @reload-data="reloadData(true)"></filters>

            <v-skeleton-loader
              v-if="!hasAllTheData"
              type="table"
              class="mx-4"
              :loading="true"
              transition="fade-transition"
            />
            <template v-else>
              <!-- aggregate table controls (search, expand, collapse, etc...) -->
              <aggregates-table-controls
                v-if="this.$route.name === 'task-summary'"
                @table-search-updated="searchUpdated"
                @expand-aggregate-table="expandAllUpdate"
                @collapse-aggregate-table="collapseAllUpdate"
                :expanding="expanding"
                :collapsing="collapsing"
                :aggRowSize="aggRowSize"
                :nonAggRowSize="nonAggRowSize"
              ></aggregates-table-controls>

              <!-- all users' aggregate table row -->
              <aggregates-table
                v-if="this.$route.name === 'task-summary'"
                :aggregateRow="true"
                :aggregatesTableDataSource="aggregatesTableAggDataSource"
                :search="search"
                :collapsed="collapseAll"
                :expanded="expandAll"
                @agg-collapse-all-finished="aggCollapseAllFinished"
                @agg-expand-all-finished="aggExpandAllFinished"
                @agg-filtered-table-updated="updateFilteredAggRowCount"
              ></aggregates-table>

              <!-- aggregate table rows grouped by user -->
              <aggregates-table
                v-if="this.$route.name === 'task-summary'"
                :aggregateRow="false"
                :aggregatesTableDataSource="aggregatesTableDataSource"
                :search="search"
                :collapsed="collapseAll"
                :expanded="expandAll"
                @collapse-all-finished="nonAggCollapseFinished"
                @expand-all-finished="nonAggExpandFinished"
                @filtered-table-updated="updateFilteredRowCount"
              ></aggregates-table>

              <!-- toggle to show empty rows -->
              <toggle-empty-rows
                v-if="this.$route.name === 'task-summary'"
                @hide-task-agg-rows="updateHideTaskAggRows"
              ></toggle-empty-rows>

              <!-- all users' agent guidance -->
              <t-s-agent-guidance
                ref="TSAgentGuidance"
                v-if="showTSAggAgentGuidance"
                :aggregateRow="true"
                @reload-data="reloadData(true)"
                :aggregatesTableDataSource="aggregatesTableAggDataSource"
              ></t-s-agent-guidance>

              <!-- selected user agent guidance -->
              <t-s-agent-guidance
                ref="TSAgentGuidance"
                v-if="showTSAgentGuidance"
                :aggregateRow="false"
                @reload-data="reloadData(true)"
                :aggregatesTableDataSource="aggregatesTableDataSource"
              ></t-s-agent-guidance>
            </template>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
const COACHING_HORIZON = 18; // months
const DEFAULT_HORIZON = 30; // days

import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "@/pages/TaskSummary/Breadcrumbs.vue";
import Filters from "@/pages/TaskSummary/Filters.vue";
import AggregatesTable from "@/pages/TaskSummary/AggregatesTable.vue";
import LoadingStatusBox from "@/components/Widgets/LoadingStatusBox.vue";
import TSAgentGuidance from "@/pages/TaskSummary/TSAgentGuidance.vue";
import cacheHandler from "@/utils/CacheHandler";
import moment from "moment";
import CacheHandler from "@/utils/CacheHandler";
import dispatchedBroadcasts from "@/mixins/dispatchedBroadcasts";
import ToggleEmptyRows from "./ToggleEmptyRows.vue";
import AggregatesTableControls from "./AggregatesTableControls.vue";

export default {
  name: "TaskSummary",
  mixins: [dispatchedBroadcasts],
  components: {
    AggregatesTable,
    Filters,
    Breadcrumbs,
    LoadingStatusBox,
    TSAgentGuidance,
    ToggleEmptyRows,
    AggregatesTableControls
  },
  data() {
    return {
      loadingDone: false,
      filterLoadingTimeout: null,
      filtersReadyInternal: false,
      hideTaskAggRows:
        cacheHandler.getItem("hide_empty_task_aggregate_rows") == "true",
      search: "",
      expandAll: false,
      collapseAll: false,
      expanding: false,
      collapsing: false,
      aggExpanding: false,
      aggCollapsing: false,
      nonAggExpanding: false,
      nonAggCollapsing: false,
      aggRowSize: 0,
      nonAggRowSize: 0
    };
  },
  methods: {
    ...mapActions("users", ["retrieveAuthorizedUserListData"]),
    ...mapActions("resources", [
      "retrieveAgentData",
      "retrieveTeamData",
      "retrieveUsersAgentsTeamsData"
    ]),
    ...mapActions("taskSummaryData", [
      "setUserNames",
      "retrieveTaskSummaryData"
    ]),
    ...mapActions('taskSummaryData', [
      'setUserNames',
      'retrieveTaskSummaryData',
      'setAggregatesTableData',
      'setFixDateRange',
    ]),
    ...mapActions('taskSummaryFilters', [
      'setCoachingDefinitionFilters',
      'setTaskTitleFilters',
      'setStartDateFilter',
      'setEndDateFilter',
      'setFiltersReady',
    ]),
    ...mapActions('broadcast', [
      'removeBroadcastAction',
    ]),
    updateFilteredAggRowCount(tableSize) {
      this.aggRowSize = tableSize;
    },
    updateFilteredRowCount(tableSize) {
      this.nonAggRowSize = tableSize;
    },
    expandAllUpdate(expand) {
      this.expandAll = expand;
      this.aggExpanding = expand;
      this.nonAggExpanding = expand;
      this.expanding = true;
    },
    collapseAllUpdate(collapse) {
      this.collapseAll = collapse;
      this.aggCollapsing = collapse;
      this.nonAggCollapsing = collapse;
      this.collapsing = true;
    },
    aggExpandAllFinished() {
      this.aggExpanding = false;
      if (!this.aggExpanding && !this.nonAggExpanding) this.expanding = false;
    },
    aggCollapseAllFinished() {
      this.aggCollapsing = false;
      if (!this.aggCollapsing && !this.nonAggCollapsing)
        this.collapsing = false;
    },
    nonAggCollapseFinished() {
      this.nonAggCollapsing = false;
      if (!this.aggCollapsing && !this.nonAggCollapsing)
        this.collapsing = false;
    },
    nonAggExpandFinished() {
      this.nonAggExpanding = false;
      if (!this.aggExpanding && !this.nonAggExpanding) this.expanding = false;
    },
    searchUpdated(searchUpdateVal) {
      this.search = searchUpdateVal;
    },
    updateHideTaskAggRows(shouldHide) {
      this.hideTaskAggRows = shouldHide;
    },
    resetRootData() {
      // route changed, we need to reset the data controls...
      this.search = ""
      this.expandAll = false
      this.collapseAll = false
      this.expanding = false
      this.collapsing = false
      this.aggExpanding = false
      this.aggCollapsing = false
      this.nonAggExpanding = false
      this.nonAggCollapsing = false
    },
    async reloadData(loadingMask) {
      const tmpFilters = {
        coaching_definition_ids: [...this.coachingDefinitionFilters],
        task_title_ids: [...this.taskTitleFilters],
        start_date: this.startDateFilter,
        end_date: this.endDateFilter
      };
      const payload = this.packPayload(tmpFilters);
      await this.retrieveTaskSummaryData(payload);
      this.$refs.filters.setLoading(false);
      this.$nextTick(() => {
        if (this.$refs.TSAgentGuidance) {
          this.$refs.TSAgentGuidance.remoteReloadGuidanceData(loadingMask);
        }
      });
    },
    adjustDatesToUTC(startDate, endDate) {
      const localOffset = moment().utcOffset(); // Get offset in minutes
      const adjustedStart = moment(startDate, "YYYY-MM-DD")
        .startOf("day") // Midnight in local time
        .utcOffset(-localOffset) // Convert to UTC
        .format("YYYY-MM-DD HH:mm:ss");
      const adjustedEnd = moment(endDate, "YYYY-MM-DD")
        .endOf("day") // 11:59:59 PM in local time
        .utcOffset(-localOffset) // Convert to UTC
        .format("YYYY-MM-DD HH:mm:ss");
      return { adjustedStart, adjustedEnd };
    },
    packPayload(filters) {
      const payload = { summary_params: {} };
      if (filters.coaching_definition_ids.length > 0)
        payload.summary_params.coaching_definition_ids =
          filters.coaching_definition_ids;
      if (filters.task_title_ids.length > 0)
        payload.summary_params.task_title_id = filters.task_title_ids; // the parameter is just id, sigh...
      const { adjustedStart, adjustedEnd } = this.adjustDatesToUTC(
        filters.start_date,
        filters.end_date
      );
      payload.summary_params.start_date = adjustedStart;
      payload.summary_params.end_date = adjustedEnd;
      return payload;
    },
    handleFilterLoad() {
      if (this.userDataLoadingStatus == "loaded") {
        // set up filters
        let lsCoachingDefinitionIds =
          cacheHandler.getItem("selectedCoachingDefinitionIds") || "";
        let lsTaskTitleIds = cacheHandler.getItem("selectedTaskTitleIds") || "";
        let lsCreateDateStartDate =
          cacheHandler.getItem("createDateStartDate", "session") || "";
        let lsCreateDateEndDate =
          cacheHandler.getItem("createDateEndDate", "session") || "";

        let valCoachingDefinitionIds = lsCoachingDefinitionIds
          .split(",")
          .filter(item => item !== "")
          .map(Number);
        let valTaskTitleIds = lsTaskTitleIds
          .split(",")
          .filter(item => item !== "")
          .map(Number);
        let valCreateDateStartDate = moment(lsCreateDateStartDate).isValid()
          ? moment(lsCreateDateStartDate).format("YYYY-MM-DD")
          : moment()
              .subtract(DEFAULT_HORIZON, "days")
              .format("YYYY-MM-DD");
        let valCreateDateEndDate = moment(lsCreateDateEndDate).isValid()
          ? moment(lsCreateDateEndDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");

        // further verify/adjust dates because time passes and shit happens
        valCreateDateStartDate = moment(valCreateDateStartDate).isBefore(
          moment().subtract(COACHING_HORIZON, "months")
        )
          ? moment()
              .subtract(COACHING_HORIZON, "months")
              .format("YYYY-MM-DD")
          : valCreateDateStartDate;
        valCreateDateEndDate = moment(valCreateDateEndDate).isSameOrAfter(
          moment(valCreateDateStartDate)
        )
          ? valCreateDateEndDate
          : moment().format("YYYY-MM-DD");

        // push any changes back into localStorage and update vuex data store
        CacheHandler.setItem(
          "selectedCoachingDefinitionIds",
          valCoachingDefinitionIds.join(",")
        );
        CacheHandler.setItem("selectedTaskTitleIds", valTaskTitleIds.join(","));
        CacheHandler.setItem(
          "createDateStartDate",
          valCreateDateStartDate,
          "session"
        );
        CacheHandler.setItem(
          "createDateEndDate",
          valCreateDateEndDate,
          "session"
        );

        this.setCoachingDefinitionFilters(valCoachingDefinitionIds);
        this.setTaskTitleFilters(valTaskTitleIds);
        this.setStartDateFilter(valCreateDateStartDate);
        this.setEndDateFilter(valCreateDateEndDate);

        this.filtersReadyInternal = true;
        this.setFiltersReady(true);
      }
    },
    async handleDataLoad() {
      if (
        this.userDataLoadingStatus == "loaded" &&
        this.agentDataLoadingStatus == "loaded" &&
        this.teamDataLoadingStatus == "loaded"
      ) {
        if (this.userDataListLoadingStatus == "loaded") {
          this.hideTaskAggRows =
            cacheHandler.getItem("hide_empty_task_aggregate_rows") == "true";

          if (this.usersAgentsTeamsDataLoadingStatus == "loaded") {
            // populate stuff so the page works
            this.setUserNames(
              this.userDataList.map(item => ({
                userid: item.userid,
                lastname: item.lastname,
                firstname: item.firstname,
                name: item.firstname + " " + item.lastname
              }))
            );

            // allow the page to load
            const tmpFilters = {
              coaching_definition_ids: [...this.coachingDefinitionFilters],
              task_title_ids: [...this.taskTitleFilters],
              start_date: this.startDateFilter,
              end_date: this.endDateFilter
            };
            const payload = this.packPayload(tmpFilters);
            this.loadingDone = true;
            payload.loadingMask = true;
            await this.retrieveTaskSummaryData(payload);
          }
        } else {
          this.retrieveAuthorizedUserListData(this.userData.id);
        }
      }
    },
    getAgentDetails(agentId) {
      return this.agentData.find(a => a.id == agentId && a.profile_type === 0);
    },
    initAgentObj(agentMapping, agentDetails, agentId, userId) {
      return {
        name: agentDetails.full_name || agentDetails.name,
        agent_id: agentDetails.id,
        scorecard: "",
        teams: agentMapping[agentId].map(tm => {
          const team = this.teamData.find(t => t.id == tm.id);
          return team
            ? { team_name: team.team_name, team_id: team.id }
            : { team_name: tm.team_name, team_id: tm.id };
        }),
        scorecards: [],
        task_summary: null,
        adjusted: null
      };
    },
    mapScorecardsToAgent(agentOverride, agentObj) {
      if (agentOverride && Array.isArray(agentOverride.scorecards)) {
        agentObj.scorecards = agentOverride.scorecards.map(sc => ({
          scorecard_name: sc.title,
          scorecard_id: sc.id
        }));
      } else {
        agentObj.scorecards = [];
      }
      return agentObj;
    },
    pushCoachAgentScUnion(agentObj, coachScorecardsUnion) {
      agentObj.scorecards.forEach(sc => {
        if (!coachScorecardsUnion.some(existing => existing.scorecard_id === sc.scorecard_id)) {
          coachScorecardsUnion.push(sc);
        }
      });
      return coachScorecardsUnion;
    },
    showAgentRow(agentObj, coachObj) {
      if (this.hideTaskAggRows && agentObj.task_summary) {
        if (this.rowObjHasData(agentObj)) coachObj.agents.push(agentObj);
      } else {
        coachObj.agents.push(agentObj);
      }
      return coachObj;
    },
    rowObjHasData(rowObj) {
      return (
        rowObj.adjusted > 0 ||
        rowObj.task_summary.task_count > 0 ||
        rowObj.task_summary.tasks_closed > 0 ||
        rowObj.task_summary.tasks_in_progress > 0 ||
        rowObj.task_summary.tasks_new > 0 ||
        rowObj.task_summary.tasks_overdue > 0 ||
        rowObj.task_summary.tasks_unread > 0 ||
        rowObj.task_summary.session_count > 0
      );
    },
    dispatchedBroadcastHandler() {
      this.taskSummaryBroadcastHandler()
      this.taskSummaryBroadcastDateRangeHandler()
    },
    doFixDateRange() {
      if (this.fixDateRange.hasOwnProperty('start_date') && this.fixDateRange.hasOwnProperty('end_date')) {
        this.$router.replace({
          query: {
            ...this.$route.query, // keep any other query params
            start_date: moment(this.fixDateRange.start_date).format('YYYY-MM-DD'),
            end_date: moment(this.fixDateRange.end_date).format('YYYY-MM-DD')
          }
        });
        this.setFixDateRange({});
      }
    }

  },
  computed: {
    ...mapGetters({
      userNames: "taskSummaryData/userNames"
    }),
    ...mapGetters({
      userData: "users/userData",
      userDataLoadingStatus: "users/userDataLoadingStatus",
      userDataLoadingError: "users/userDataLoadingError",
      userDataLoadingErrorStatus: "users/userDataLoadingErrorStatus",
      userDataList: "users/userDataList",
      userDataListLoadingStatus: "users/userDataListLoadingStatus",
      userDataListLoadingError: "users/userDataListLoadingError",
      userDataListLoadingErrorStatus: "users/userDataListLoadingErrorStatus"
    }), 
    ...mapGetters({
      agentData: "resources/agentData",
      agentDataLoadingStatus: "resources/agentDataLoadingStatus",
      agentDataLoadingError: "resources/agentDataLoadingError",
      agentDataLoadingErrorStatus: "resources/agentDataLoadingErrorStatus",
      teamData: "resources/teamData",
      teamDataLoadingStatus: "resources/teamDataLoadingStatus",
      teamDataLoadingError: "resources/teamDataLoadingError",
      teamDataLoadingErrorStatus: "resources/teamDataLoadingErrorStatus",
      usersAgentsTeamsData: "resources/usersAgentsTeamsData",
      usersAgentsTeamsDataLoadingStatus:
        "resources/usersAgentsTeamsDataLoadingStatus",
      usersAgentsTeamsDataLoadingError:
        "resources/usersAgentsTeamsDataLoadingError",
      usersAgentsTeamsDataLoadingErrorStatus:
        "resources/usersAgentsTeamsDataLoadingErrorStatus",
      aggUsersAgentsTeamsData: "resources/aggUsersAgentsTeamsData"
    }),
    ...mapGetters({
      coachingDefinitionsData: "taskSummaryData/coachingDefinitionsData",
      coachingDefinitionsDataLoadingStatus:
        "taskSummaryData/coachingDefinitionsDataLoadingStatus",
      taskTitlesData: "taskSummaryData/taskTitlesData",
      taskTitlesDataLoadingStatus:
        "taskSummaryData/taskTitlesDataLoadingStatus",
      scorecardsListData: "taskSummaryData/scorecardsListData",
      scorecardsListDataLoadingStatus:
        "taskSummaryData/scorecardsListDataLoadingStatus",
      scorecardsOverridesData: "taskSummaryData/scorecardsOverridesData",
      scorecardsOverridesDataLoadingStatus:
        "taskSummaryData/scorecardsOverridesDataLoadingStatus",
      scorecardsAggOverridesData: "taskSummaryData/scorecardsAggOverridesData",
      scorecardsAggOverridesDataLoadingStatus:
        "taskSummaryData/scorecardsAggOverridesDataLoadingStatus",
      taskSummaryData: "taskSummaryData/taskSummaryData",
      taskSummaryDataLoadingStatus:
        "taskSummaryData/taskSummaryDataLoadingStatus",
      taskSummaryDataLoadingError:
        "taskSummaryData/taskSummaryDataLoadingError",
      taskSummaryDataLoadingErrorStatus:
        "taskSummaryData/taskSummaryDataLoadingErrorStatus",

      taskAggSummaryData: "taskSummaryData/taskAggSummaryData",
      taskAggSummaryDataLoadingStatus:
        "taskSummaryData/taskAggSummaryDataLoadingStatus"
    }),
    ...mapGetters({
      broadcastActionList: "broadcast/broadcastActionList",
      coachingDefinitionsData: 'taskSummaryData/coachingDefinitionsData',
      coachingDefinitionsDataLoadingStatus: 'taskSummaryData/coachingDefinitionsDataLoadingStatus',
      taskTitlesData: 'taskSummaryData/taskTitlesData',
      taskTitlesDataLoadingStatus: 'taskSummaryData/taskTitlesDataLoadingStatus',
      scorecardsListData: 'taskSummaryData/scorecardsListData',
      scorecardsListDataLoadingStatus: 'taskSummaryData/scorecardsListDataLoadingStatus',
      scorecardsOverridesData: 'taskSummaryData/scorecardsOverridesData',
      scorecardsOverridesDataLoadingStatus: 'taskSummaryData/scorecardsOverridesDataLoadingStatus',
      taskSummaryData: 'taskSummaryData/taskSummaryData',
      taskSummaryDataLoadingStatus: 'taskSummaryData/taskSummaryDataLoadingStatus',
      taskSummaryDataLoadingError: 'taskSummaryData/taskSummaryDataLoadingError',
      taskSummaryDataLoadingErrorStatus: 'taskSummaryData/taskSummaryDataLoadingErrorStatus',
      fixDateRange: 'taskSummaryData/fixDateRange',
    }),
    ...mapGetters({
      coachingDefinitionFilters: "taskSummaryFilters/coachingDefinitionFilters",
      taskTitleFilters: "taskSummaryFilters/taskTitleFilters",
      startDateFilter: "taskSummaryFilters/startDateFilter",
      endDateFilter: "taskSummaryFilters/endDateFilter",
      filtersReady: "taskSummaryFilters/filtersReady"
    }),
    hasAllTheData() {
      return (
        this.taskSummaryDataLoadingStatus == "loaded" &&
        this.userDataLoadingStatus == "loaded" &&
        this.userDataListLoadingStatus == "loaded" &&
        this.agentDataLoadingStatus == "loaded" &&
        this.teamDataLoadingStatus == "loaded" &&
        this.usersAgentsTeamsDataLoadingStatus == "loaded" &&
        this.coachingDefinitionsDataLoadingStatus == "loaded" &&
        this.scorecardsListDataLoadingStatus == "loaded" &&
        this.scorecardsOverridesDataLoadingStatus == "loaded" &&
        this.taskAggSummaryDataLoadingStatus == "loaded"
      );
    },
    showTSAgentGuidance() {
      return (
        (this.$route.name == "task-summary-user" ||
          this.$route.name == "task-summary-user-agents" ||
          this.$route.name == "task-summary-user-agent") &&
        this.filtersReady
      );
    },
    showTSAggAgentGuidance() {
      return (
        (this.$route.name == "task-summary-all-user" ||
          this.$route.name == "task-summary-all-user-all-agents" ||
          this.$route.name == "task-summary-all-user-agent") &&
        this.filtersReady
      );
    },
    // used by dispatchedBroadcasts.js
    preloadDataReady() {
      return (
        this.userDataLoadingStatus == "loaded" &&
        this.agentDataLoadingStatus == "loaded" &&
        this.teamDataLoadingStatus == "loaded"
      );
    },
    aggregatesTableDataSource() {
      // Use this.usersAgentsTeamsData, this.userData, etc. directly so that reactivity is preserved.
      const validCoachIds = Object.keys(this.usersAgentsTeamsData);
      const currentUserId = this.userData.id;
      const coaches = [this.userData, ...this.userDataList.filter(u => validCoachIds.includes(String(u.userid)) && u.userid !== currentUserId)];

      return coaches
        .map(coach => {
          const firstname = coach.firstName || coach.firstname || "";
          const lastname = coach.lastName || coach.lastname || "";
          const coachName = firstname && lastname ? `${firstname} ${lastname}`.trim() : coach.name || coach.username || "";
          const user_id = coach.userid || coach.id;
          const agentMapping = this.usersAgentsTeamsData[String(user_id)] || {};

          let coachObj = {
            user_id,
            name: coachName,
            firstname: firstname,
            lastname: lastname,
            scorecard: "", // Will be computed later.
            teams: [],
            scorecards: [],
            agents: [],
            task_summary:
              this.taskSummaryData && this.taskSummaryData[String(user_id)]
                ? this.taskSummaryData[String(user_id)].totals
                : null,
            adjusted:
              this.scorecardsOverridesData &&
              this.scorecardsOverridesData[String(user_id)]
                ? this.scorecardsOverridesData[String(user_id)]
                    .total_adjustments
                : null
          };

          let coachScorecardsUnion = [];

          Object.keys(agentMapping).forEach(agentId => {
            const agentDetails = this.getAgentDetails(agentId);
            if (agentDetails) {
              let agentObj = this.initAgentObj(
                agentMapping,
                agentDetails,
                agentId,
                user_id
              );

              // Merge teams.
              agentObj.teams.forEach(t => {
                if (!coachObj.teams.some(ct => ct.team_id === t.team_id)) {
                  coachObj.teams.push(t);
                }
              });

              // Look up the agent's override.
              let agentOverride = null;
              if (this.scorecardsOverridesData && this.scorecardsOverridesData[String(user_id)]) {
                agentOverride = this.scorecardsOverridesData[String(user_id)].agents.find(o => o.agent_id == agentObj.agent_id);
              }
              agentObj = this.mapScorecardsToAgent(agentOverride, agentObj);
              agentObj.scorecard = agentObj.scorecards
                .map(sc => sc.scorecard_name)
                .join(", ");

              // Add to coach's union.
              coachScorecardsUnion = this.pushCoachAgentScUnion(
                agentObj,
                coachScorecardsUnion
              );

              // Task summary.
              if (this.taskSummaryData && this.taskSummaryData[String(user_id)]) {
                const agentTask = this.taskSummaryData[String(user_id)].agents.find(a => a.id == agentObj.agent_id);
                agentObj.task_summary = agentTask ? agentTask.data : null;
              } else {
                agentObj.task_summary = null;
              }

              // Adjusted value.
              if (this.scorecardsOverridesData && this.scorecardsOverridesData[String(user_id)]) {
                const agentOverrideForAdjusted = this.scorecardsOverridesData[String(user_id)].agents.find(o => o.agent_id == agentObj.agent_id);
                agentObj.adjusted = agentOverrideForAdjusted ? agentOverrideForAdjusted.adjustments : null;
              } else {
                agentObj.adjusted = null;
              }
              coachObj = this.showAgentRow(agentObj, coachObj);
            }
          });

          coachObj.scorecards = coachScorecardsUnion;
          coachObj.scorecard = coachScorecardsUnion.map(sc => sc.scorecard_name).join(", ");
          return coachObj;
        })
        .filter(coach => { return this.hideTaskAggRows && coach.task_summary ? this.rowObjHasData(coach) : coach; });
    },

    aggregatesTableAggDataSource() {
      // Use this.usersAgentsTeamsData, this.userData, etc. directly so that reactivity is preserved.
      const firstname = "All";
      const lastname = "Users";
      const coachName = firstname + " " + lastname;
      const user_id = 0;
      const agentMapping = this.aggUsersAgentsTeamsData || {};

      let coachObj = {
        user_id,
        name: coachName,
        firstname: firstname,
        lastname: lastname,
        scorecard: "", // Will be computed later.
        teams: [],
        scorecards: [],
        agents: [],
        task_summary:
          this.taskAggSummaryData && this.taskAggSummaryData.totals
            ? this.taskAggSummaryData.totals
            : null,
        adjusted:
          this.scorecardsAggOverridesData &&
          this.scorecardsAggOverridesData.total_adjustments
            ? this.scorecardsAggOverridesData.total_adjustments
            : null
      };
      let coachScorecardsUnion = [];

      Object.keys(agentMapping).forEach(agentId => {
        const agentDetails = this.getAgentDetails(agentId);
        if (agentDetails) {
          let agentObj = this.initAgentObj(
            agentMapping,
            agentDetails,
            agentId,
            user_id
          );

          // Merge teams.
          agentObj.teams.forEach(t => {
            if (!coachObj.teams.some(ct => ct.team_id === t.team_id)) {
              coachObj.teams.push(t);
            }
          });

          // Look up the agent's override.
          let agentOverride = null;
          if (this.scorecardsAggOverridesData && this.scorecardsAggOverridesData.agents) {
            agentOverride = this.scorecardsAggOverridesData.agents.find(
              o => o.agent_id == agentObj.agent_id
            );
          }
          agentObj = this.mapScorecardsToAgent(agentOverride, agentObj);
          agentObj.scorecard = agentObj.scorecards
            .map(sc => sc.scorecard_name)
            .join(", ");

          // Add to coach's union.
          coachScorecardsUnion = this.pushCoachAgentScUnion(
            agentObj,
            coachScorecardsUnion
          );

          // Task summary.
          if (this.taskAggSummaryData && this.taskAggSummaryData.agents) {
            const agentTask = this.taskAggSummaryData.agents.find(a => a.id == agentObj.agent_id);
            agentObj.task_summary = agentTask ? agentTask.data : null;
          } else {
            agentObj.task_summary = null;
          }

          // Adjusted value.
          if (
            this.scorecardsOverridesData &&
            this.scorecardsAggOverridesData.agents
          ) {
            const agentOverrideForAdjusted = this.scorecardsAggOverridesData.agents.find(o => o.agent_id == agentObj.agent_id);
            agentObj.adjusted = agentOverrideForAdjusted ? agentOverrideForAdjusted.adjustments : null;
          } else {
            agentObj.adjusted = null;
          }
          coachObj = this.showAgentRow(agentObj, coachObj);
        }
      });

      coachObj.scorecards = coachScorecardsUnion;
      coachObj.scorecard = coachScorecardsUnion.map(sc => sc.scorecard_name).join(", ");
      return [coachObj];
    }
  },
  mounted() {
    this.filtersReadyInternal = false;
    if (this.agentDataLoadingStatus != "loaded") {
      this.retrieveAgentData();
    }
    this.retrieveTeamData();
    this.retrieveUsersAgentsTeamsData();
    this.handleFilterLoad();
  },
  watch: {
    userDataLoadingStatus: "handleFilterLoad",
    userDataListLoadingStatus: "handleDataLoad",
    agentDataLoadingStatus: "handleDataLoad",
    teamDataLoadingStatus: "handleDataLoad",
    usersAgentsTeamsDataLoadingStatus: "handleDataLoad",
    filtersReady: "handleDataLoad",
    filtersReadyInternal(newVal) {
      if (newVal) {
        this.handleDataLoad();
      }
    },
    broadcastActionList: "dispatchedBroadcastHandler",
    fixDateRange: 'doFixDateRange',
    "$route.name": "resetRootData"
  }
};
</script>

<style scoped></style>
